'use client';
import {FaInstagram} from 'react-icons/fa';
import {FaLinkedinIn} from 'react-icons/fa';

type SocialIconProps = {
  type: 'instagram' | 'linkedin';
  ariaLabel: string;
};

export default function SocialIcon({type, ariaLabel}: SocialIconProps) {
  const Icon = type === 'instagram' ? FaInstagram : FaLinkedinIn;

  return <Icon className="w-5 h-5" aria-label={ariaLabel} />;
}
